"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.clamp = void 0;
const clamp = (value, min, max) => {
    return Math.max(min, Math.min(max, value));
};
exports.clamp = clamp;
//# sourceMappingURL=clamp.js.map